const sizes = {
    huge : "3rem",
    big : "2rem",
    medium:"1.5rem"
    ,small : "1rem"
}
export default sizes